import { render, staticRenderFns } from "./selectProducts.vue?vue&type=template&id=969871f2&scoped=true&"
import script from "./selectProducts.vue?vue&type=script&lang=js&"
export * from "./selectProducts.vue?vue&type=script&lang=js&"
import style0 from "./selectProducts.vue?vue&type=style&index=0&id=969871f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969871f2",
  null
  
)

export default component.exports